import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import {
  getActiveSection,
  getPlaygroundSubsection,
  getIsProductsSection,
  getIsSearchPage,
  getPublishedTierId,
} from '../../selectors/studio';
import { Props } from './StudioBlankSlate';

export type StateProps = Pick<
  Props,
  | 'activeSection'
  | 'activePlaygroundSection'
  | 'isProductsSection'
  | 'isSearchPage'
  | 'selectedTierId'
>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  return {
    activeSection: getActiveSection(state),
    activePlaygroundSection: getPlaygroundSubsection(state),
    isProductsSection: getIsProductsSection(state),
    isSearchPage: getIsSearchPage(state),
    selectedTierId: getPublishedTierId(state),
  };
};

export default connect(mapStateToProps);
